import { inject, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppGuard } from './services/auth.guard';

import { ListagemAgendamentoComponent } from './pages/agendamento/listagem-agendamento/listagem-agendamento.component';
import { CadastroFuncionarioComponent } from './pages/funcionario/cadastro-funcionario/cadastro-funcionario.component';
import { ListagemFuncionarioComponent } from './pages/funcionario/listagem-funcionario/listagem-funcionario.component';
import { ListagemEmpresaComponent } from './pages/empresa/listagem-empresa/listagem-empresa.component';
import { TransferenciaEmpresaComponent } from './pages/empresa/transferencia-empresa/transferencia-empresa.component';
import { HomeComponent } from './pages/home/home.component';
import { LoginComponent } from './pages/login/login.component';
import { ListagemParametrizacaoComponent } from './pages/parametrizacao/patio/listagem-parametrizacao/listagem-parametrizacao.component';
import { CadastroPrecificacaoComponent } from './pages/parametrizacao/precificacao/cadastro-precificacao/cadastro-precificacao.component';
import { ListagemPrecificacaoComponent } from './pages/parametrizacao/precificacao/listagem-precificacao/listagem-precificacao.component';
import { CadastroServicoComponent } from './pages/parametrizacao/servicos/cadastro-servico/cadastro-servico.component';
import { ListagemServicoComponent } from './pages/parametrizacao/servicos/listagem-servico/listagem-servico.component';
import { EmailSenhaComponent } from './pages/recuperar-senha/email-senha/email-senha.component';
import { EsqueciSenhaComponent } from './pages/recuperar-senha/esqueci-senha/esqueci-senha.component';
import { ListagemEntradaGateComponent } from './pages/entrada-gate/listagem-entrada-gate/listagem-entrada-gate.component';
import { CadastroEntradaComponent } from './pages/entrada-gate/cadastro-entrada/cadastro-entrada.component';
import { ListagemServicosComponent } from './pages/servicos/listagem-servicos/listagem-servicos.component';
import { CadastroEntradaServicosComponent } from './pages/servicos/cadastro-entrada-servicos/cadastro-entrada-servicos.component';
import { ListagemLaudosHigienizacaoComponent } from './pages/laudo-higienizacao/listagem-laudos-higienizacao/listagem-laudos-higienizacao.component';
import { CadastroLaudoHigienizacaoComponent } from './pages/laudo-higienizacao/cadastro-laudo-higienizacao/cadastro-laudo-higienizacao.component';
import { ListagemDesengatesComponent } from './pages/desengate/listagem-desengates/listagem-desengates.component';
import { CadastroDesengateComponent } from './pages/desengate/cadastro-desengate/cadastro-desengate.component';
import { ListagemEngatesComponent } from './pages/engate/listagem-engates/listagem-engates.component';
import { CadastroEngateComponent } from './pages/engate/cadastro-engate/cadastro-engate.component';
import { CadastroEntradaEstacionamentoTpgComponent } from './pages/estacionamento-tpg/cadastro-entrada-estacionamento-tpg/cadastro-entrada-estacionamento-tpg.component';
import { ListagemEstacionamentoTpgComponent } from './pages/estacionamento-tpg/listagem-estacionamento-tpg/listagem-estacionamento-tpg.component';
import { CadastroSaidaEstacionamentoTpgComponent } from './pages/estacionamento-tpg/cadastro-saida-estacionamento-tpg/cadastro-saida-estacionamento-tpg.component';
import { CadastroSaidaGateComponent } from './pages/saida-gate/cadastro-saida-gate/cadastro-saida-gate.component';
import { ListagemSaidaGateComponent } from './pages/saida-gate/listagem-saida-gate/listagem-saida-gate.component';
import { ListagemCaixaComponent } from './pages/caixa/listagem-caixa/listagem-caixa.component';
import { RelatorioPlacasCaixaComponent } from './pages/relatorios/relatorio-placas-caixa/relatorio-placas-caixa.component';
import { RelatorioClientesCaixaComponent } from './pages/relatorios/relatorio-clientes-caixa/relatorio-clientes-caixa.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { CadastroParametrizacaoAcessosComponent } from './pages/gestao-acesso/cadastro-parametrizacao-acessos/cadastro-parametrizacao-acessos.component';
import { ListagemOrdemServicoComponent } from './pages/empresa/listagem-ordem-servico/listagem-ordem-servico.component';
import { ListagemLogsComponent } from './pages/logs/listagem-logs/listagem-logs.component';
import { CadastroHigienizacaoAgendadaComponent } from './pages/higienizacao-agendada/cadastro-higienizacao-agendada/cadastro-higienizacao-agendada.component';
import { ListagemHigienizacaoAgendadaComponent } from './pages/higienizacao-agendada/listagem-higienizacao-agendada/listagem-higienizacao-agendada.component';
import { CadastroAgendamentoComponent } from './pages/agendamento/cadastro-agendamento/cadastro-agendamento.component';
import { ListagemMotoristasComponent } from './pages/motoristas/listagem-motoristas/listagem-motoristas.component';
import { VisualizacaoMotoristaComponent } from './pages/motoristas/visualizacao-motorista/visualizacao-motorista.component';
import { ListagemBlacklistComponent } from './pages/parametrizacao/blacklist/listagem-blacklist/listagem-blacklist.component';
import { FormBlacklistComponent } from './pages/parametrizacao/blacklist/form-blacklist/form-blacklist.component';
import { QuantidadeVeiculosPatioComponent } from './pages/relatorios/quantidade-veiculos-patio/quantidade-veiculos-patio.component';
import { LaudosEditadosComponent } from './pages/relatorios/laudos-editados/laudos-editados.component';
import { HistoricoVeiculoComponent } from './pages/relatorios/historico-veiculo/historico-veiculo.component';
import { DashboardServicosComponent } from './pages/relatorios/dashboard-servicos/dashboard-servicos.component';
import { DashboardPatioComponent } from './pages/relatorios/dashboard-patio/dashboard-patio.component';
import { DashboardFinanceiroComponent } from './pages/relatorios/dashboard-financeiro/dashboard-financeiro.component';
import { LaudosExcluidosCanceladosComponent } from './pages/relatorios/laudos-excluidos-cancelados/laudos-excluidos-cancelados.component';
import { RelatorioLaudoServicoComponent } from './pages/relatorios/relatorio-laudo-servico/relatorio-laudo-servico.component';
import { RelatorioFinanceiroPatioComponent } from './pages/relatorios/relatorio-financeiro-patio/relatorio-financeiro-patio.component';
import { ListagemTransportadoraComponent } from './pages/transportadora/listagem-transportadora/listagem-transportadora.component';
import { CadastroTransportadoraComponent } from './pages/transportadora/cadastro-transportadora/cadastro-transportadora.component';
import { ConsultaPosicaoPatioComponent } from './pages/posicao-patio/consulta-posicao-patio/consulta-posicao-patio.component';
import { ListagemFilaDestinatarioComponent } from './pages/parametrizacao/fila-destinatario/listagem-fila-destinatario/listagem-fila-destinatario.component';
import { ToleranciaParametrizacaoComponent } from './pages/parametrizacao/tolerancia/tolerancia-parametrizacao.component';
import { NotificacoesParametrizacaoComponent } from './pages/parametrizacao/notificacoes/notificacoes-parametrizacao.component';
import { ListagemJanelaComponent } from './pages/parametrizacao/janela/listagem-janela/listagem-janela.component';
import { RelatoriosGeraisComponent } from './pages/relatorios/relatorios-gerais/relatorios-gerais.component';
import { ListagemProdutoComponent } from './pages/estoque/produtos/listagem-produto/listagem-produto.component';
import { CadastroProdutoComponent } from './pages/estoque/produtos/cadastro-produto/cadastro-produto.component';
import { ListagemEstoqueComponent } from './pages/estoque/listagem-estoque/listagem-estoque.component';
import { CadastroEntradaEstoqueComponent } from './pages/estoque/entrada-estoque/cadastro-entrada-estoque/cadastro-entrada-estoque.component';
import { CadastroSaidaEstoqueComponent } from './pages/estoque/saida-estoque/cadastro-saida-estoque/cadastro-saida-estoque.component';
import { CadastroAjusteEstoqueComponent } from './pages/estoque/ajuste/cadastro-ajuste-estoque/cadastro-ajuste-estoque.component';
import { DashboardEstoqueComponent } from './pages/estoque/dashboard-estoque/dashboard-estoque.component';
import { RelatorioEstoqueComponent } from './pages/estoque/relatorios/relatorio-estoque/relatorio-estoque.component';
import { ListagemCaixaEstoqueComponent } from './pages/caixa/listagem-caixa-estoque/listagem-caixa-estoque.component';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [() => inject(AppGuard).canActivate()]
  },
  { path: 'recuperar-senha', component: EmailSenhaComponent },
  { path: 'esqueci-senha', component: EsqueciSenhaComponent },
  { path: 'esqueci-senha-interno', component: EsqueciSenhaComponent },
  {
    path: 'listagem',
    children: [
      {
        path: 'agendamento',
        component: ListagemAgendamentoComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'parametrizacao',
        component: ListagemParametrizacaoComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'funcionario',
        component: ListagemFuncionarioComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'empresa/transferencia',
        component: TransferenciaEmpresaComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'empresa',
        component: ListagemEmpresaComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'servico',
        component: ListagemServicoComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'precificacao',
        component: ListagemPrecificacaoComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'blacklist',
        component: ListagemBlacklistComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'patio',
        component: ListagemParametrizacaoComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'entrada-gate',
        component: ListagemEntradaGateComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'servicos',
        component: ListagemServicosComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'laudos-higienizacao',
        component: ListagemLaudosHigienizacaoComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'desengates',
        component: ListagemDesengatesComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'engates',
        component: ListagemEngatesComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'estacionamento-tpg',
        component: ListagemEstacionamentoTpgComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'saida-gate',
        component: ListagemSaidaGateComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'caixa',
        component: ListagemCaixaComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'caixa-estoque',
        component: ListagemCaixaEstoqueComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'estoque/produtos',
        component: ListagemProdutoComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'estoque',
        component: ListagemEstoqueComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'estoque/inventario',
        redirectTo: 'estoque/relatorio-estoque',
        pathMatch: 'full'
      },
      {
        path: 'estoque/movimentacoes',
        redirectTo: 'estoque/relatorio-estoque',
        pathMatch: 'full'
      },
      {
        path: 'estoque/dashboard',
        component: DashboardEstoqueComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'estoque/relatorio-estoque',
        component: RelatorioEstoqueComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'estoque/relatorio-vendas',
        redirectTo: 'estoque/relatorio-estoque',
        pathMatch: 'full'
      },
      {
        path: 'estoque/relatorio-movimentacoes',
        redirectTo: 'estoque/relatorio-estoque',
        pathMatch: 'full'
      },
      {
        path: 'estoque/relatorio-posicao',
        redirectTo: 'estoque/relatorio-estoque',
        pathMatch: 'full'
      },
      {
        path: 'ordem-servico',
        component: ListagemOrdemServicoComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'logs',
        component: ListagemLogsComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'higienizacao-agendada',
        component: ListagemHigienizacaoAgendadaComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'motoristas-externo',
        component: ListagemMotoristasComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'relatorios',
        redirectTo: 'relatorios/relatorio-veiculos',
        pathMatch: 'full'
      },
      {
        path: 'relatorios/relatorio-veiculos',
        component: QuantidadeVeiculosPatioComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'relatorios/quantidade-veiculos-patio',
        redirectTo: 'relatorios/relatorio-veiculos',
        pathMatch: 'full'
      },
      {
        path: 'relatorios/quantidade-veiculos-periodo',
        component: QuantidadeVeiculosPatioComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'relatorios/quantidade-veiculos-agendados-periodo',
        component: QuantidadeVeiculosPatioComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'relatorios/quantidade-veiculos-saida-periodo-janela',
        component: QuantidadeVeiculosPatioComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'relatorios/quantidade-veiculos-transportadora',
        component: QuantidadeVeiculosPatioComponent,
      },
      {
        path: 'relatorios/laudos-editados',
        component: LaudosEditadosComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'relatorios/laudos-servico',
        component: RelatorioLaudoServicoComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'relatorios/financeiro-patio',
        component: RelatorioFinanceiroPatioComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'relatorios/dashboard',
        redirectTo: 'relatorios/dashboard-servicos',
        pathMatch: 'full'
      },
      {
        path: 'relatorios/dashboard-servicos',
        component: DashboardServicosComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'relatorios/dashboard-patio',
        component: DashboardPatioComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'relatorios/dashboard-financeiro',
        component: DashboardFinanceiroComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'relatorios/historico-veiculo',
        component: HistoricoVeiculoComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'relatorios/laudos-excluidos-cancelados',
        component: LaudosExcluidosCanceladosComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'relatorios/relatorios-gerais',
        component: RelatoriosGeraisComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'relatorios/relatorio-terminal',
        redirectTo: 'relatorios/relatorios-gerais',
        pathMatch: 'full'
      },
      {
        path: 'relatorios/historico-alteracoes',
        component: ListagemLogsComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'relatorios/relatorio-terminal-laudos',
        redirectTo: 'relatorios/relatorios-gerais',
        pathMatch: 'full'
      },
      {
        path: 'relatorios/relatorio-carregamento-laudos',
        redirectTo: 'relatorios/relatorios-gerais',
        pathMatch: 'full'
      },
      {
        path: 'relatorios/relatorio-carregamento-quantitativo',
        redirectTo: 'relatorios/relatorios-gerais',
        pathMatch: 'full'
      },
      {
        path: 'relatorios/relatorio-carregamento-detalhado',
        redirectTo: 'relatorios/relatorios-gerais',
        pathMatch: 'full'
      },
      {
        path: 'relatorios/relatorio-cliente-laudos',
        redirectTo: 'relatorios/relatorios-gerais',
        pathMatch: 'full'
      },
      {
        path: 'relatorios/relatorio-cliente-quantitativo',
        redirectTo: 'relatorios/relatorios-gerais',
        pathMatch: 'full'
      },
      {
        path: 'relatorios/relatorio-cliente-detalhado',
        redirectTo: 'relatorios/relatorios-gerais',
        pathMatch: 'full'
      },
      {
        path: 'relatorios/relatorio-mensal-laudos',
        redirectTo: 'relatorios/relatorios-gerais',
        pathMatch: 'full'
      },
      {
        path: 'relatorios/relatorio-quantidade-cliente-laudos',
        redirectTo: 'relatorios/relatorios-gerais',
        pathMatch: 'full'
      },
      {
        path: 'relatorios/vendas-por-produto',
        redirectTo: 'estoque/relatorio-estoque',
        pathMatch: 'full'
      },
      {
        path: 'relatorios/relatorio-placas-caixa',
        component: RelatorioPlacasCaixaComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'relatorios/relatorio-clientes-caixa',
        redirectTo: 'estoque/relatorio-estoque',
        pathMatch: 'full'
      },
      {
        path: 'transportadora',
        component: ListagemTransportadoraComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      }
    ]
  },
  {
    path: 'cadastro',
    children: [
      {
        path: 'blacklist',
        component: FormBlacklistComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'parametrizacao',
        component: ListagemParametrizacaoComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'funcionario',
        component: CadastroFuncionarioComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'servico',
        component: CadastroServicoComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'precificacao',
        component: CadastroPrecificacaoComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'agendamento',
        component: CadastroAgendamentoComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'entrada',
        component: CadastroEntradaComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'servicos',
        component: CadastroEntradaServicosComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'laudo-higienizacao',
        component: CadastroLaudoHigienizacaoComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'desengate',
        component: CadastroDesengateComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'engate',
        component: CadastroEngateComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'entrada-estacionamento-tpg',
        component: CadastroEntradaEstacionamentoTpgComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'saida-estacionamento-tpg',
        component: CadastroSaidaEstacionamentoTpgComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'saida-gate',
        component: CadastroSaidaGateComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'caixa',
        component: ListagemCaixaComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'parametrizacao-acessos',
        component: CadastroParametrizacaoAcessosComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'higienizacao-agendada',
        component: CadastroHigienizacaoAgendadaComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'transportadora',
        component: CadastroTransportadoraComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'estoque/produto',
        component: CadastroProdutoComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'estoque/entrada',
        component: CadastroEntradaEstoqueComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'estoque/saida',
        component: CadastroSaidaEstoqueComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'estoque/ajuste',
        component: CadastroAjusteEstoqueComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      }
    ]
  },
  {
    path: 'visualizacao',
    children: [
      {
        path: 'motorista-externo',
        component: VisualizacaoMotoristaComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      }
    ]
  },
  {
    path: 'consulta',
    children: [
      {
        path: 'posicao-patio',
        component: ConsultaPosicaoPatioComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      }
    ]
  },
  {
    path: 'parametrizacao',
    children: [
      {
        path: 'servico',
        component: CadastroServicoComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'precificacao',
        component: CadastroPrecificacaoComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'patio',
        component: ListagemParametrizacaoComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'fila-destinatario',
        component: ListagemFilaDestinatarioComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'tolerancia',
        component: ToleranciaParametrizacaoComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'notificacoes',
        component: NotificacoesParametrizacaoComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      },
      {
        path: 'janela',
        component: ListagemJanelaComponent,
        canActivate: [() => inject(AppGuard).canActivate()]
      }
    ]
  },
  {
    path: '**',
    component: NotFoundComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
